export default {"src":"/_next/static/media/white-scale.15380e7c.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};